import { immerable } from "immer";

import { tableViews } from "@/composables/_commons/helper.js";

export default class DemosTableConfig {
  [immerable] = true;

  constructor(title, downloadRegisters, columns, rows) {
    return {
      api: rows,
      schema: columns,
      views: tableViews(),
      pagination: {
        pageSize: 50,
        availableOptions: [10, 25, 50, 100],
      },
      behaviour: {
        useQuery: false,
      },
      actions: {
        header: [
          {
            label: "Descargar información",
            icon: "download",
            command: () => downloadRegisters(),
            extended: true,
          },
        ],
      },
    };
  }
}
